import { sizeFrame } from "../../iframe/iframe";

export default function($, iframe){
    if($('.alektionen').first().data('responsive') == '1'){
        $('.alektionen').stacktable();
        sizeFrame(iframe?.data?.id);
    }
}